interface Props {
  text: string;
}

export function LoadingIndicator({ text }: Props) {
  return (
    <div className="loading-container">
      <div className="text-center p-4">
        <div className="spinner-border text-primary" role="status"></div>
        <p className="mt-2 text-muted">{text}</p>
      </div>
    </div>
  );
}
